import { PassouFalhouEnum } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/enums-consultaSeguimento'
import { calculateResultadoPergunta01 } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/perguntas/consulta-seguimento-pergunta-01/utils-consultaSeguimentoPergunta01'
import { MchatRfAplicacaoQueryModel } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/model-mChatRf'

import { HistoricoMchatExemplosPassouFalhouTableItem } from '../components/HistoricoMchatExemplosPassouFalhouTableItem'
import { HistoricoMChatHeaderTableItem } from '../components/HistoricoMchatHeaderTableItem'
import { HistoricoMChatPerguntaSection } from '../components/HistoricoMchatPerguntaSection'
import { HistoricoMChatResultadoParcialTableItem } from '../components/HistoricoMChatResultadoParcialTableItem'
import { HistoricoMChatSimpleHorizontalTableItem } from '../components/HistoricoMChatSimpleHorizontalTableItem'
import { convertAplicacaoPergunta01 } from './converter-HistoricoMchatPergunta01'

interface HistoricoMChatRfPergunta01Props {
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
}

export const HistoricoMChatRfPergunta01 = (props: Readonly<HistoricoMChatRfPergunta01Props>) => {
  const { aplicacoes } = props

  const converted = convertAplicacaoPergunta01(aplicacoes)
  if (converted == null) return null

  const { header, exemplosPassou, exemplosFalhou, perguntaMaiorFrequencia, model } = converted
  if (header.stPassou === null || header.stPassou === undefined) return null

  const resultado = calculateResultadoPergunta01(model)

  return (
    <HistoricoMChatPerguntaSection>
      <HistoricoMChatHeaderTableItem
        numeroPergunta='1'
        title={header.textoPergunta}
        value={header.stPassou}
        pergunta='“Por favor, me dê um exemplo de como ele responde se você apontar para algo.”'
      />
      <HistoricoMchatExemplosPassouFalhouTableItem exemplosPassou={exemplosPassou} exemplosFalhou={exemplosFalhou} />
      {perguntaMaiorFrequencia && (
        <HistoricoMChatSimpleHorizontalTableItem
          pergunta={perguntaMaiorFrequencia.textoPergunta}
          resposta={'Exemplos ' + (perguntaMaiorFrequencia.stPassou ? 'PASSOU' : 'FALHOU')}
        />
      )}
      {resultado && <HistoricoMChatResultadoParcialTableItem valor={resultado === PassouFalhouEnum.PASSOU} />}
    </HistoricoMChatPerguntaSection>
  )
}
